//==============================================================================

import { initialise as initialiseRdf } from '@celldl/rdf'
import { defineAsyncComponent } from 'vue'

// Initialise the RDF store backend before the editor is imported

const ViewerComponent = defineAsyncComponent(async () => {
    await initialiseRdf()
    return import('./WrappedViewer.vue')
})

export default ViewerComponent

//==============================================================================
